export const COLLEGE = {
  name: "Megha Institute of Engineering and Technology for Women",
  short: "MIETW",
  tagline: "Engineering the Future with MEGHA",
  heading: "B.Tech Admissions Open 2026",
  accreditation: "UGC Autonomous · Accredited by NAAC 'A' Grade",
  codes: ["EAPCET", "ECET", "ICET", "PGECET", "POLYCET"],
  codeWord: "MGHA",
  highestPackage: "36 LPA",
  location: "Ghatkesar, Hyderabad",
  phones: ["+91 78159 10875", "+91 92468 05889"],
  whatsapp: "917815910875",
  website: "www.meghaengg.ac.in",
  email: "admissions@meghaengg.ac.in",
};

export const PROGRAMS = [
  {
    code: "CSE",
    title: "Computer Science & Engineering",
    icon: "Cpu",
    desc: "Foundational and advanced computing — algorithms, systems, software engineering, full-stack development.",
    careers: ["Software Engineer", "Backend Developer", "Systems Architect"],
  },
  {
    code: "CS&IT",
    title: "Computer Science & Information Technology",
    icon: "Network",
    desc: "Networks, cloud, DevOps and modern IT infrastructure. Cross-disciplinary applied computing.",
    careers: ["Cloud Engineer", "DevOps", "IT Consultant"],
  },
  {
    code: "AI&DS",
    title: "Artificial Intelligence & Data Science",
    icon: "BarChart3",
    desc: "Data engineering, statistical learning, deep learning — production-grade AI for real-world problems.",
    careers: ["Data Scientist", "ML Engineer", "AI Researcher"],
  },
  {
    code: "AI&ML",
    title: "Artificial Intelligence & Machine Learning",
    icon: "Brain",
    desc: "Modern ML, large models, generative AI, MLOps. Build intelligent systems end-to-end.",
    careers: ["ML Engineer", "Applied Scientist", "Prompt Engineer"],
  },
  {
    code: "ECE",
    title: "Electronics & Communication Engineering",
    icon: "Radio",
    desc: "VLSI, embedded systems, 5G/6G communications, IoT and signal processing.",
    careers: ["Embedded Engineer", "VLSI Designer", "RF Engineer"],
  },
  {
    code: "EEE",
    title: "Electrical & Electronics Engineering",
    icon: "Zap",
    desc: "Power systems, renewable energy, electric mobility and smart grid technologies.",
    careers: ["Power Engineer", "EV Engineer", "Grid Specialist"],
  },
  {
    code: "CE",
    title: "Civil Engineering",
    icon: "Building2",
    desc: "Structural design, smart infrastructure, sustainable construction and urban planning.",
    careers: ["Structural Engineer", "Site Engineer", "Urban Planner"],
  },
];

export const COURSE_OPTIONS = PROGRAMS.map((p) => ({ value: p.code, label: `${p.code} — ${p.title}` }));

export const WHY_CHOOSE = [
  { icon: "GraduationCap", title: "Experienced Faculty", desc: "PhD-led mentors with deep industry expertise." },
  { icon: "FlaskConical", title: "Modern Laboratories", desc: "Future-ready labs across CS, AI, electronics and civil." },
  { icon: "Lightbulb", title: "Innovation & Research", desc: "Active R&D cells, patents and student startups." },
  { icon: "Handshake", title: "Industry Collaborations", desc: "MoUs with top tech firms for live projects." },
  { icon: "Sparkles", title: "Women Empowerment", desc: "A campus designed for women to lead in engineering." },
  { icon: "Briefcase", title: "Campus Placements", desc: "Strong T&P cell. Highest package: 36 LPA." },
  { icon: "Home", title: "Hostel & Transport", desc: "Safe, comfortable hostels and reliable transport." },
  { icon: "Target", title: "Skill Development", desc: "Soft skills, certifications and internship support." },
];

export const ADMISSION_STEPS = [
  { step: "01", title: "Register Online", desc: "Submit the inquiry form or apply via the official portal.", icon: "PenLine" },
  { step: "02", title: "Submit Documents", desc: "Upload academic records, ID proof and entrance scorecard.", icon: "FileText" },
  { step: "03", title: "Counseling Process", desc: "Attend counseling with our admissions officer.", icon: "Users" },
  { step: "04", title: "Fee Payment", desc: "Pay seat-confirmation fee online or at campus.", icon: "CreditCard" },
  { step: "05", title: "Admission Confirmed", desc: "Receive enrollment letter and orientation schedule.", icon: "CheckCircle2" },
];

export const TESTIMONIALS = [
  {
    name: "Priya Reddy",
    branch: "CSE · Batch 2024",
    quote: "MIETW shaped my engineering career. The placement cell pushed me to crack a 22 LPA offer in my final year.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    name: "Sneha Kulkarni",
    branch: "AI&ML · Batch 2025",
    quote: "The AI labs and faculty mentorship made me confident enough to publish my first research paper.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    name: "Ananya Sharma",
    branch: "ECE · Alumna",
    quote: "From hostel to higher studies abroad — MIETW gave me a launchpad I never expected as a first-gen engineer.",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&h=200&q=80",
  },
  {
    name: "Mrs. Lakshmi Devi",
    branch: "Parent of Civil ’24 student",
    quote: "As parents we valued the safety and care. Our daughter is now an Assistant Engineer at a top PSU.",
    avatar: "https://images.unsplash.com/photo-1545167622-3a6ac756afa4?auto=format&fit=crop&w=200&h=200&q=80",
  },
];

export const FAQS = [
  {
    q: "What is the eligibility for B.Tech admissions at MIETW?",
    a: "Candidates must have passed 10+2 with Physics, Chemistry & Mathematics with the minimum percentage prescribed by JNTUH/TGCHE, and a valid rank in EAPCET / ECET / ICET / PGECET / POLYCET. Our admission code is MGHA.",
  },
  {
    q: "What are the admission codes for MIETW?",
    a: "MIETW admission code is MGHA across all major entrance examinations — EAPCET, ECET, ICET, PGECET and POLYCET.",
  },
  {
    q: "Are scholarships available?",
    a: "Yes. Merit-based scholarships, government schemes (e.g., Telangana EPASS) and special women-in-STEM scholarships are available. Speak to our admissions desk for details.",
  },
  {
    q: "Is hostel and transport available?",
    a: "We have safe, fully-furnished hostels with hygienic food and 24/7 security. Campus bus routes cover all major parts of Hyderabad and Ghatkesar.",
  },
  {
    q: "What about placements?",
    a: "Our placement cell partners with leading IT, core engineering and consulting companies. Our highest package this year is 36 LPA with strong average packages across CSE, AI&ML and AI&DS.",
  },
  {
    q: "How do I start the admission process?",
    a: "Submit the inquiry form on this page or call us at +91 78159 10875. Our counsellor will guide you through the entire process — from documentation to seat confirmation.",
  },
];

export const STATS = [
  { value: 36, suffix: " LPA", label: "Highest Package" },
  { value: 300, suffix: "+", label: "Recruiters" },
  { value: 95, suffix: "%", label: "Placement Rate" },
  { value: 7, suffix: "", label: "B.Tech Programs" },
];

// Verified high-quality Unsplash/Pexels URLs
export const IMAGES = {
  heroBg: "https://images.unsplash.com/photo-1581091215367-9b6c00b3035a?auto=format&fit=crop&w=1600&q=80",
  heroStudent: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=900&q=80",
  about: "https://meghaengg.ac.in/files/mietw-building.webp",
  campusLab: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=900&q=80",
  campusBuilding: "https://meghaengg.ac.in/files/mietw-building.webp",
  campusStudents: "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?auto=format&fit=crop&w=900&q=80",
  campusWorkshop: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=900&q=80",
  campusGraduation: "https://images.unsplash.com/photo-1627556704302-624286467c65?auto=format&fit=crop&w=900&q=80",
  campusLibrary: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=900&q=80",
  campusSports: "https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=900&q=80",
  campusCultural: "https://images.unsplash.com/photo-1492538368677-f6e0afe31dcc?auto=format&fit=crop&w=900&q=80",
  videoPoster: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=1600&q=80",
};

export const RECRUITERS = [
  "TCS", "Infosys", "Wipro", "Accenture", "Cognizant", "Capgemini",
  "Tech Mahindra", "HCL", "L&T", "Deloitte", "IBM", "Amazon", "Microsoft", "Adobe",
];
